import React, { useState } from 'react';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { copyReferralLink } from '../../util/referral';

import Modal from '../Modal/Modal';
import { SecondaryButton } from '../Button/Button';

import css from './ReferralShareModal.module.css';

const ReferralShareModal = props => {
  const { id, isOpen, onClose, onManageDisableScrolling = () => {}, title, text, url } = props;
  const intl = useIntl();
  const [status, setStatus] = useState(null);
  const sharedText = encodeURIComponent(`${text}\n${url}`);
  const emailSubject = encodeURIComponent(title);

  const close = () => {
    setStatus(null);
    onClose();
  };
  const copy = () => {
    copyReferralLink(url)
      .then(() => setStatus('copied'))
      .catch(() => setStatus('error'));
  };

  return (
    <Modal
      id={id}
      containerClassName={css.modal}
      contentClassName={css.content}
      isOpen={isOpen}
      onClose={close}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={intl.formatMessage({ id: 'ReferralShareModal.close' })}
    >
      <h2 className={css.title}>
        <FormattedMessage id="ReferralShareModal.title" />
      </h2>
      <p className={css.text}>
        <FormattedMessage id="ReferralShareModal.description" />
      </p>
      <div className={css.options}>
        <a
          className={css.option}
          href={`https://wa.me/?text=${sharedText}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp
        </a>
        <a className={css.option} href={`sms:?&body=${sharedText}`}>
          <FormattedMessage id="ReferralShareModal.textMessage" />
        </a>
        <a className={css.option} href={`mailto:?subject=${emailSubject}&body=${sharedText}`}>
          Email
        </a>
        <SecondaryButton type="button" onClick={copy}>
          <FormattedMessage id="InviteUserControl.copy" />
        </SecondaryButton>
      </div>
      {status ? (
        <p className={css.status} role="status">
          <FormattedMessage id={`InviteUserControl.${status}`} />
        </p>
      ) : null}
    </Modal>
  );
};

export default ReferralShareModal;
